<template>
  <div class="pointer white-bg col-12 py1 px2 my2 card-top border" @click="handleClick(price.index)">
    <div class="col-12 flex justify-between">
      <div class="col-8 md-col-6">
        <div class="col-12 inline-block">
          <h2 class="h2 mt1 mb0">{{ price.label.toLowerCase() }}</h2>
        </div>
        <div v-if="price.period" class="col-12 inline-block">
          <span class="h5">{{ price.period.name }}</span>
        </div>
        <div class="col-12 inline-block">
          <span v-if="price.conditions" class="h5">{{ price.conditions.title }}</span>
        </div>
        <div v-if="!price.isGymlibTariff" class="col-12 md-col-4 md-hide lg-hide inline-block">
          <span :class="['bold', { 'crossed': computePromo(price).canShow}]">
            <span v-if="price.price > 0" class="h2">
              {{ tariffPrice }} €
            </span>
            <span v-else class="h4">
              OFFERT
            </span>
          </span>
          <span v-if="computePromo(price).canShow" class="ml1 h2 bold">{{ (computePromo(price).price / 100).toFixed(2) }} €</span>
          <span v-if="isRecurring" class="h4">/ mois</span>
        </div>
      </div>
      <div v-if="!price.isGymlibTariff" class="col-4 md-col-4 flex justify-end items-center xs-hide sm-hide">
        <!-- <div v-if="price.originalPrice && price.originalPrice !== price.price" class="mr2">Pro Rata Prix</div> -->
        <div class="flex flex-column">
          <span :class="['h2 bold center']">
            <div v-if="computePromo(price).canShow">
              <div class="crossed">
                {{ tariffPrice }} €
              </div>
              <div>
                {{ (computePromo(price).price / 100).toFixed(2) }} €
              </div>
            </div>
            <span v-else-if="price.price > 0">
              {{ tariffPrice }} €
            </span>
            <span v-else class="h3">
              OFFERT
            </span>
          </span>
        </div>
        <span v-if="isRecurring" class="ml1 bold h4">/ mois</span>
      </div>
      <div class="col-2 md-col-2 flex justify-center items-center">
        <span :class="['custom-radio flex ', { 'selected-item': isSelectedTariff }]"></span>
      </div>
    </div>
    <GymlibCodeValidator v-if="price.isGymlibTariff && isSelectedTariff" :price="price.negotiatedPrice" @validate-code="validateCode" />
  </div>
</template>

<script>
import GymlibCodeValidator from '@/components/tariffs/GymlibCodeValidator';
import { computePromo } from '@/utils/logics';

export default {
  components: { GymlibCodeValidator },
  props: {
    price: {
      type: Object,
      required: true
    },
    isRecurring: {
      type: Boolean,
      default: false
    },
    selectedTariff: {
      type: Number,
      required: true
    },
    codeValid: {
      type: Boolean,
      default: false
    },
    handleClick: {
      type: Function,
      required: true
    }
  },
  computed: {
    tariffPrice () {
      return parseFloat(this.price.price / 100).toFixed(2);
    },
    isSelectedTariff () {
      return this.selectedTariff === this.price.index;
    }
  },
  methods: {
    computePromo,
    validateCode (event) {
      this.$emit('validateCode', event);
    }
  }
};
</script>

<style>

</style>
